import { Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CategoryStore from '@/stores/product/category.store';

export default abstract class AbstractFlyoutMenu extends Vue {
  protected categoryStore = getModule(CategoryStore, this.$store);

  get rootCategories() {
    return this.categoryStore.rootCategories;
  }
}
